"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        MISSING: {
            label: 'Missing',
        },
        PENDING: {
            label: 'Pending',
        },
        REFUSED: {
            label: 'Refused',
        },
        VALIDATED: {
            label: 'Validated',
        },
    },
    fr: {
        MISSING: {
            label: 'Manquant',
        },
        PENDING: {
            label: 'En attente',
        },
        REFUSED: {
            label: 'Refusé',
        },
        VALIDATED: {
            label: 'Validé',
        },
    },
};
